export type { Configuration } from './configurationConsumer';
export {
    configurationConsumer,
    getConfig,
    getConfigByKey,
    loadConfig,
    loadServerConfig,
} from './configurationConsumer';
